import React from "react";
import PropTypes from "prop-types";
import { Switch, Route } from "react-router-dom";

import SimpleRoute from "../SimpleRoute";

const NestingRoute = ({
  path: originalPath,
  nesting,
  isHome = false,
  isNotes = false,
  isProduct = false,
  scrollTop = true,
  ...props
}) => (
  <Route path={originalPath}>
    <Switch>
      <SimpleRoute
        exact
        path={originalPath}
        isHome={isHome}
        isNotes={isNotes}
        isProduct={isProduct}
        scrollTop={scrollTop}
        {...props}
      />
      {nesting.map(({ path: subRoutePath, ...rest }) => (
        <SimpleRoute
          key={subRoutePath}
          isHome={isHome}
          isNotes={isNotes}
          isProduct={isProduct}
          path={`${originalPath}${subRoutePath}`}
          scrollTop={scrollTop}
          {...rest}
        />
      ))}
    </Switch>
  </Route>
);

NestingRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
  nesting: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      component: PropTypes.elementType.isRequired,
      exact: PropTypes.bool.isRequired
    }).isRequired
  ).isRequired,
  scrollTop: PropTypes.bool
};

export default NestingRoute;
